import { render, staticRenderFns } from "./Ressources.vue?vue&type=template&id=603e3db6&"
import script from "./Ressources.vue?vue&type=script&lang=js&"
export * from "./Ressources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports